import { Badge } from "@/components/ui/Badge"
import { shortDate, units } from "@/lib/format"
import type { IncomingLine } from "../types"

interface Props {
  lines: IncomingLine[]
  today: string
  empty?: string
}

// Order lines on the way: quantity, order number, status, arrival day. A
// line past its arrival day is flagged Late (the chart lands it today).
export default function IncomingList({ lines, today, empty }: Props) {
  if (lines.length === 0) return <p className="text-sm text-foreground">{empty}</p>

  return (
    <div className="flex flex-col">
      <div className="hidden pb-1 text-xs font-medium text-foreground sm:grid sm:grid-cols-4 sm:gap-3">
        <span>Quantity</span>
        <span>Order</span>
        <span>Status</span>
        <span className="text-right">Arrives</span>
      </div>
      {lines.map((line, index) => (
        <div key={`${line.order_no ?? "none"}-${index}`} className="flex flex-col gap-0.5 py-1 text-sm text-foreground sm:grid sm:grid-cols-4 sm:gap-3">
          <span className="tabular-nums">{units(line.quantity)}</span>
          <span className="truncate">{line.order_no ?? "No order number"}</span>
          <span>{line.status}</span>
          <span className="flex items-center gap-2 sm:justify-end">
            {line.arrives_on && line.arrives_on < today && <Badge variant="danger">Late</Badge>}
            {line.arrives_on ? shortDate(line.arrives_on, today) : "No arrival date"}
          </span>
        </div>
      ))}
    </div>
  )
}
